var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor remove-from-segment" }, [
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.segment"))),
        ]),
        _vm._v(" "),
        _c("SegmentPicker", {
          model: {
            value: _vm.clone.segmentId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "segmentId", $$v)
            },
            expression: "clone.segmentId",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }